import React from "react"
import { Redirect } from "react-router-dom"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"

const CompetitiveTierRedirect = ({ children }) => {
  const { isTierConfirmed, isAdmin } = useSelector(({ user }) => {
    const hasUser = Object.keys(user?.user).length > 0

    return {
      isTierConfirmed: hasUser ? user?.user?.tier_confirmed : true,
      isAdmin: hasUser ? user?.user?.role?.id === 1 : false
    }
  })

  // Admins bypass tier gating entirely
  if (!isAdmin && !isTierConfirmed) {
    return <Redirect to="/application/status" />
  }

  return children
}

CompetitiveTierRedirect.propTypes = {
  children: PropTypes.node.isRequired
}

export default CompetitiveTierRedirect
